import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.jsx";
import "./i18n";
import "./index.css";
import "./platformscode-layer.css";
import "./App.css";
import "./components/shared/side-pic.css";
// fonts.css MUST be last — its @font-face declarations override the DGA library's
// which lack font-display:swap, causing the "Font display" audit warning.
import "./fonts.css";


if (import.meta.env.PROD) {
  console.log = () => { };
  console.warn = () => { };
  console.error = () => { };
  console.info = () => { };
  console.debug = () => { };
}

function ShellRemover({ children }) {
  useEffect(() => {
    const shell = document.getElementById('app-shell');
    if (!shell) return;

    // In production the main CSS link has data-defer-shell and is loaded as
    // preload+onload (non-blocking). Wait for it before revealing the app
    // so the first visible frame is fully styled (no FOUC).
    const deferredLink = document.querySelector('link[data-defer-shell]');

    if (!deferredLink) { shell.remove(); return; } // dev or no deferred link

    // Already converted to stylesheet (fast network / cached)
    if (deferredLink.rel === 'stylesheet') { shell.remove(); return; }

    const onLoaded = () => shell.remove();
    document.addEventListener('css-loaded', onLoaded, { once: true });
    deferredLink.addEventListener('error', onLoaded, { once: true }); // still remove on error
  }, []);
  return children;
}

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <HelmetProvider>
      <ShellRemover>
        <App />
      </ShellRemover>
    </HelmetProvider>
  </StrictMode>
);
